module.exports = ({ config }) => {
  // SECURITY: never put OPTICODDS_API_KEY (or any server secret) in `extra` —
  // everything in `extra` ships inside the public JS bundle. All OpticOdds
  // calls go through the Cloud Functions proxy, which holds the key.
  return {
    expo: {
      name: 'BetOptimized',
      slug: 'bet-optimized',
      version: '1.1.2',
      orientation: 'portrait',
      icon: './assets/icon.png',
      userInterfaceStyle: 'automatic',
      web: {
        bundler: 'webpack',
        favicon: './assets/favicon.png',
        indexHtmlPath: './web/index.html'
      },
      newArchEnabled: true,
      splash: {
        image: './assets/splash-icon.png',
        resizeMode: 'contain',
        backgroundColor: '#ffffff'
      },
      ios: { supportsTablet: true },
      android: {
        adaptiveIcon: { foregroundImage: './assets/adaptive-icon.png', backgroundColor: '#ffffff' },
        edgeToEdgeEnabled: true
      },
      extra: {
        // Production unless USE_EMULATOR=true or ?emulator=true. The old
        // 127.0.0.1:5001 default made localhost ticker/search fail whenever
        // the Functions emulator was not running.
        FUNCTIONS_BASE_URL: process.env.FUNCTIONS_BASE_URL || 'https://us-central1-bet-optimized-fe922.cloudfunctions.net',
        EXPO_PUBLIC_FUNCTIONS_BASE_URL: process.env.EXPO_PUBLIC_FUNCTIONS_BASE_URL || process.env.FUNCTIONS_BASE_URL || 'https://us-central1-bet-optimized-fe922.cloudfunctions.net',
        STRIPE_PUBLISHABLE_KEY: process.env.STRIPE_PUBLISHABLE_KEY || '',
        /* Legacy single publishable key (optional if test+live set below) */
        EXPO_PUBLIC_STRIPE_PUBLISHABLE_KEY:
          process.env.EXPO_PUBLIC_STRIPE_PUBLISHABLE_KEY || process.env.STRIPE_PUBLISHABLE_KEY || '',
        EXPO_PUBLIC_STRIPE_PUBLISHABLE_KEY_TEST:
          process.env.EXPO_PUBLIC_STRIPE_PUBLISHABLE_KEY_TEST || '',
        EXPO_PUBLIC_STRIPE_PUBLISHABLE_KEY_LIVE:
          process.env.EXPO_PUBLIC_STRIPE_PUBLISHABLE_KEY_LIVE || '',
        /* Sentry public DSN — safe to ship in the client bundle (public DSN by design) */
        EXPO_PUBLIC_SENTRY_DSN: process.env.EXPO_PUBLIC_SENTRY_DSN || '',
      }
    }
  };
};


